import { render, staticRenderFns } from "./navigationChildFooter.vue?vue&type=template&id=24ba4ba1&"
import script from "./navigationChildFooter.vue?vue&type=script&lang=js&"
export * from "./navigationChildFooter.vue?vue&type=script&lang=js&"
import style0 from "./navigationChildFooter.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports